<template>
	<div class="reader">

		<el-carousel interval="2000" indicator-position="outside" height="32vw">
			<el-carousel-item v-for="item in carouselItem" :key="item">
				<el-image style="width: 100%; height: 100%" :src="item.url"></el-image>
			</el-carousel-item>
		</el-carousel>
		<!--    <div class="sousuo">
      <el-input
        placeholder="请输入评级编号"
        class="input-with-select"
        size="large"
        v-model="ratingVal"
      >
        <template #append>
          <el-button @click="goReting()">点击查询</el-button>
        </template>
      </el-input>
    </div> -->

		<div class="zhubody">
			<div class="zhu-server">
				<h5 class="main-title">经营业务</h5>
				<div class="server-business">

					<div class="zhu-img">
						<div class="img-one-div">
							<div class="img-div"><img src="../assets/img/biz/gqpjd.jpg" /></div>
							<div class="content">
								<h4>古钱币鉴定</h4>
								<p>每一枚古钱币至少由两名鉴定师进行鉴定评估，以保证钱币评级的准确性。本公司拒绝人情分，对于钱币分数实事求是，确保评级的公平性。</p>
							</div>
						</div>

						<div class="img-one-div">
							<div class="img-div"><img src="../assets/img/biz/yyjd.jpg" /></div>
							<div class="content">
								<h4>银元鉴定</h4>
								<p>每一枚银元评级我们都会确保准确性和公平性，并且银元评级标准我们采用的是非常严谨的分数体系，有任何缺陷都会用代码标出来。以确保藏友收藏的银元质量。</p>
							</div>
						</div>
					</div>

					<div class="zhu-img">
						<div class="img-one-div">
							<div class="content">
								<h4>杂项鉴定</h4>
								<p>杂项鉴定包含铜器、瓷器、木器、玉器等等…每一项都有专业的鉴定师对具体年代进行判断，评级完成后会进行封装入盒或者打吊牌，并且拍图上传官网。</p>
							</div>
							<div class="img-div"><img src="../assets/img/biz/zxjd.png"  /></div>
						</div>

						<div class="img-one-div">
							<div class="content">
								<h4>诚招代理</h4>
								<p>本公司常年招收代理，我们对代理有全新的评级收费标准以及制度，并且有丰厚的任务奖励，欢迎各位泉友踊跃报名，具体报名方式请联系客服。</p>
							</div>
							<div class="img-div"><img src="../assets/img/biz/czdl.jpg"  /></div>
						</div>
					</div>
				</div>


				<div class="news-body">
					<h5 class="main-title">新闻公告</h5>
					<div class="news">
						<el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true>
							<el-tab-pane label="最新公告" name="first">
								<div class="news-div">
									<ul>
										<li v-for="item in announcementlist" :key="item" @click="goContent(item)">
											<div class="icon-div">
												<el-icon class="icon-right">
													<DArrowRight />
												</el-icon>
											</div>
											<a href="#">{{item.title}}</a><span>{{item.dateTime}}</span>
										</li>
									</ul>
								</div>
							</el-tab-pane>
							<el-tab-pane label="新闻动态" name="second">
								<div class="news-div">
									<ul>
										<li v-for="item in newlist" :key="item" @click="goContent(item)">
											<div class="icon-div">
												<el-icon class="icon-right">
													<DArrowRight />
												</el-icon>
											</div>
											<a href="#">{{item.title}}</a><span>{{item.dateTime}}</span>
										</li>
									</ul>
								</div>

							</el-tab-pane>
						</el-tabs>

					</div>
				</div>
				<!-- 公司 -->
				<h5 class="main-title">公司简介</h5>
				<div class="introduce">

					<div class="introduce-body">
						<div class="body-left">
							<h5>开封政泉艺术品鉴定有限公司</h5>
							<p>&nbsp; &nbsp;&nbsp;&nbsp; 开封市政泉艺术品鉴定有限公司（简称政泉评级），是开封市首批针对古钱币、银币进行鉴定评估的公司。
							<br>&nbsp; &nbsp;&nbsp;&nbsp;公司设立在八朝古都开封，钱币文化底蕴深厚，氛围好，玩家众多。公司业务包含对历代古钱币、机制银币、机制铜元、杂项鉴定评估，每一枚钱币至少两位评级师进行鉴定评估，确保钱币鉴定结果的准确性。公司宗旨就是坚持初心、优化服务。专注严谨、公平公正。让每一位泉友能够放心购买钱币，为每一位泉友的藏品保驾护航。</p>
								<p>&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
								&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;--开封政泉艺术品鉴定有限公司</p>
							<video class="vlog" src="https://zqjdimg.oss-cn-shanghai.aliyuncs.com/mv/jieshao.mp4" controls="true">
								<source src="https://zqjdimg.oss-cn-shanghai.aliyuncs.com/mv/jieshao.mp4" type="video/mp4">
							</video>
						</div>
						<div class="body-right">
							<div class="right-container" style="margin-top: 70px;">
								<el-carousel type="card" interval="1500" indicator-position="none" height="20vw">
									<el-carousel-item v-for="item in groupIntroImgList" :key="item">
										<el-image style="height: 100%;" :src="item.url"></el-image>
									</el-carousel-item>
								</el-carousel>

							</div>

						</div>
					</div>
				</div>

				<!------------------------------------------------------------------ 关于 我们 --------------------------------->
				<!-- <h5 class="main-title">关于我们</h5>
        <div class="about">
          
          <div class="about_us">
          
            <div class="about-logo">
              <div><img src = "../assets/logo.png"/></div>
              <div><h2>X X X X X X X X 有限公司</h2></div>
              
            </div>
            <div class="about-text">
              <div class="about-content">
                <p>成立于XXXX年，是一家专注于XXXXXX的XXXXX公司，XXXXXX
                  XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
                  XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</p>
              </div>
              <el-button type="primary" @click="this.$router.push('/About')">了解更多</el-button>
            </div>
          </div>
        </div> -->

			</div>
		</div>
	</div>
</template>

<script>
	import {
		DArrowRight
	} from '@element-plus/icons'
	import {
		Search
	} from '@element-plus/icons-vue'

	import Video from 'video.js'
	import 'video.js/dist/video-js.css'

	export default {
		components: {
			DArrowRight,
			Search
		},
		data() {
			return {
				//评级搜索框
				ratingVal: '',
				//轮播图
				carouselItem: [{
						url: require("../assets/img/lunbo/lunbo01.jpg")
					},
					// {
					// 	url: require("../assets/img/lunbo/lunbo02.jpg")
					// },
					{
						url: require("../assets/img/lunbo/lunbo03.jpg")
					}
				],
				groupIntroImgList: [{
						url: require("../assets/img/logo/biglogo.jpg")
					},
					{
						url: require("../assets/img/logo/biglogo.jpg")
					},
					{
						url: require("../assets/img/logo/biglogo.jpg")
					},
					{
						url: require("../assets/img/logo/biglogo.jpg")
					}
				],
				//标签页
				activeName: 'first',
				announcementlist: [{
						id: 7,
						title: '开封政泉艺术品鉴定有限公司官方平台上线啦！！！',
						dateTime: '2022年3月1号'
					},
					{
						id: 8,
						title: '河南郑州第三十一届全国红色收藏品交流会',
						dateTime: '2022年3月8号'
					},
					{
						id: 9,
						title: '江苏章友会第二届精品徽章展销会暨徐州古玩城第二十一届全国古玩钱币交流会',
						dateTime: '2022年3月10号'
					},
					// {
					// 	id: 10,
					// 	title: '收藏金银币要循序渐进',
					// 	dateTime: '2022-01-01 12:00:01'
					// },
					// {
					// 	id: 11,
					// 	title: '我们的专业能力',
					// 	dateTime: '2022-01-01 12:00:01'
					// },
					// {
					// 	id: 12,
					// 	title: '金银币如何收藏与投资',
					// 	dateTime: '2022-01-01 12:00:01'
					// },
				],
				newlist: [{
						id: 1,
						title: '开封政泉艺术品鉴定有限公司官方平台上线啦！！！',
						dateTime: '2022年3月1号'
					},
					{
						id: 2,
						title: '河南郑州第三十一届全国红色收藏品交流会',
						dateTime: '2022年3月8号'
					},
					{
						id: 3,
						title: '江苏章友会第二届精品徽章展销会暨徐州古玩城第二十一届全国古玩钱币交流会',
						dateTime: '2022年3月10号'
					}
					// {
					// 	id: 5,
					// 	title: '了解古钱币的收藏基础知识',
					// 	dateTime: '2022-01-01 12:00:01'
					// },
					// {
					// 	id: 6,
					// 	title: '2015年羊年纪念币价值',
					// 	dateTime: '2022-01-01 12:00:01'
					// },
				]
			}
		},
		methods: {
			//标签页
			handleClick(tab, event) {
				console.log(tab, event);
			},

			//新闻跳转
			goContent(item) {
				this.$router.push({
					path: '/News/' + item.id,
				})
			},
			//查询鉴定
			goReting() {
				this.$router.push({
					path: '/Reting/' + this.ratingVal
				})
			}
		},

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.reader {
		font-size: 14px;

		//轮播图
		.el-carousel__item:nth-child(2n) {
			background-color: #99a9bf;
		}

		.el-carousel__item:nth-child(2n + 1) {
			background-color: #d3dce6;
		}



		//-----------------------------------------------min-标题-----------------------------------------------
		.main-title {
			text-align: center;
			//border-left: 5px solid #606266;
			font-size: 30px;
			width: 300px;
			margin: 0 auto;
			padding: 10px 0;
			margin-bottom: 40px;
			cursor: default;
			position: relative;

			@media only screen and (max-width: 600px) {
				margin-bottom: 20px;
			}

			@media only screen and (max-width: 500px) {
				margin-bottom: 0;
			}

			&::after {
				content: "";
				position: absolute;
				left: 0%;
				top: 50%;
				bottom: -3px;
				width: 100px;
				height: 3px;
				margin-left: -50px;
				background-color: #e22434;
			}

			&::before {
				content: "";
				position: absolute;
				right: -17%;
				top: 50%;
				bottom: -3px;
				width: 100px;
				height: 3px;
				margin-left: -50px;
				background-color: #e22434;
			}
		}

		@media only screen and (max-width: 760px) {
			.main-title {
				font-size: 25px;
			}
		}

		//-----------------------------------------------搜索-----------------------------------------------

		.sousuo {
			padding: 0 10%;

			@media only screen and (max-width: 1055px) {
				display: none;
			}
		}

		//-----------------------------------------------主营业务-----------------------------------------------
		.zhubody {
			width: 100%;
			margin-top: 30px;
		}

		@media only screen and (max-width: 1410px) {
			.zhubody {
				width: 100%;
			}

		}

		.zhu-server {
			//background: #F2F6FC;

			.server-business {
				width: 1400px;
				margin: 0 auto;
				position: relative;

				@media only screen and (max-width: 1400px) {
					width: 100%;
				}

				.zhu-img {
					position: relative;
					display: flex;
					justify-content: center;

					@media only screen and (max-width: 1000px) {
						display: flex;
						flex-wrap: wrap;
					}

					.img-one-div {
						display: flex;
						border: 1px solid #e9e9e9;
						cursor: pointer;

						@media only screen and (max-width: 1400px) {
							width: 50%;
						}

						@media only screen and (max-width: 1000px) {
							width: 600px;
							margin-top: 20px;
						}

						@media only screen and (max-width: 550px) {
							max-height: 180px;
						}

						@media only screen and (max-width: 500px) {
							width: 90%;
							max-height: 160px;
						}

						@media only screen and (max-width: 450px) {
							max-height: 150px;
						}

						@media only screen and (max-width: 400px) {
							max-height: 140px;
						}

						&:hover {
							transition: all 0.9s;
							border: 1px solid #E22434;

							img {
								transform: scale(1.5, 1.1);
							}
						}

						.img-div {
							overflow: hidden;
							height: 229px;

							img {
								width: 349px;
								height: 249px;
								transition: all 0.6s;

								@media only screen and (max-width: 1400px) {
									max-width: 100%;
								}

								@media only screen and (max-width: 550px) {

									max-height: 180px;
								}

								@media only screen and (max-width: 500px) {

									max-height: 160px;
								}

								@media only screen and (max-width: 450px) {
									max-height: 150px;
								}

								@media only screen and (max-width: 400px) {
									max-height: 140px;
								}
							}
						}
					}

					.content {
						padding: 20px;
						width: 308px;
						height: 110px;
						color: #666666;

						@media only screen and (max-width: 1200px) {
							width: 301px;
						}

						@media only screen and (max-width: 1065px) {
							width: 295px;
						}

						@media only screen and (max-width: 500px) {
							padding: 10px;
							width: 275px;
						}

						@media only screen and (max-width: 400px) {
							max-height: 140px;
						}

						h4 {
							font-size: 20px;
							color: #265190;
							text-align: center;
							margin: 25px 0;
							font-family: 楷体;

							@media only screen and (max-width: 500px) {
								font-size: 15px;
								margin: 10px 0;
							}

							@media only screen and (max-width: 450px) {
								margin: 5px 0;
							}

							@media only screen and (max-width: 400px) {
								margin: 0;
							}
						}

						p {
							font-size: 18px;
							font-family: 楷体;
							@media only screen and (max-width: 500px) {
								font-size: 0.78125rem;
								margin: 10px 0;
							}
							
							@media only screen and (max-width: 450px) {
								margin: 5px 0;
							}
							
							@media only screen and (max-width: 400px) {
								margin: 0;
							}
						}
					}
				}
			}

		}

		//-----------------------------------------------新闻-----------------------------------------------
		.news-body {
			.main-title {
				margin-top: 50px;
			}
		}

		.news {
			width: 1400px;
			margin: 0 auto;

			@media only screen and (max-width: 1400px) {
				width: 100%;
			}

			.news-div {
				padding: 3px;
				text-align: left;
				//background: #F2F6FC;
				border-radius: 10px;
				padding: 10px;

				ul {
					margin: 10px 0;
					padding: 0 5px;

					li {
						list-style: none;
						font-size: 14px;
						line-height: 40px;
						border-bottom: 1px solid #DFDFDF;
						cursor: pointer;
						display: flex;
						transition: .5s;

						:before {
							content: '';
							position: absolute;
							bottom: 0;
							left: 0;
							width: 100%;
							height: 1px;
							background: #e22434;
							transform: scaleX(0);
							transform-origin: 0%;
							transition: .5s;
						}

						:hover:before {
							transform: scaleX(1);
						}

						&:hover {
							margin-left: 10px;

							a,
							span {
								color: #e22434;
							}

							.icon-right {
								color: #e22434;
							}
						}

						.icon-div {
							padding-top: 2px;
							margin-right: 5px
						}

						a {
							position: relative;
							display: block;
							color: #666666;
							text-transform: uppercase;
							text-decoration: none;
							white-space: nowrap;
							text-overflow: ellipsis;
							overflow: hidden;
							width: 70%;

							@media only screen and (max-width: 650px) {
								width: 60%;
							}

							@media only screen and (max-width: 480px) {
								width: 50%;
							}
						}

						span {
							width: 130px;
							padding: 0;
							color: #979595;
							margin-left: 20px;

							@media only screen and (max-width: 480px) {
								margin-left: 20px;
								font-size: 10px;
								width: 115px;
							}
						}
					}
				}
			}
		}

		//-----------------------------------------------公司简介-----------------------------------------------

		.introduce {
			width: 1400px;
			margin: 0 auto;
			margin-top: 40px;

			@media only screen and (max-width: 1400px) {
				width: 100%;
			}

			.introduce-body {
				display: flex;

				@media only screen and (max-width: 580px) {
					display: block;
				}

				.body-left {
					width: 60%;
					background: #E4E7ED;
					padding-left: 80px;
						
					@media only screen and (max-width: 1060px) {
						padding-left: 10px;
					}

					@media only screen and (max-width: 580px) {
						width: 98%;
					}

					h5 {
						font-size: 16px;
						padding: 10px 0;
						border-bottom: 1px solid #d3dce6;
						width: 600px;
						margin: 0 auto;
						margin-bottom: 10px;

						@media only screen and (max-width: 1030px) {
							margin-left: 0%;
							width: 100%;
						}
					}

					p {
						font-size: 15px;
						line-height: 25px;
						text-align: left;
						margin: 0 auto;
						margin-right: 15px;
						@media only screen and (max-width: 1250px) {
							margin-left: 15%;
						}

						@media only screen and (max-width: 1200px) {
							margin-left: 10%;
						}

						@media only screen and (max-width: 980px) {
							word-break: break-all;
							word-wrap: break-word;
							width: 90%;
							margin-left: 0%;
						}
					}

					.vlog {
						margin-top: 20px;
						margin-bottom: 30px;
						width: 400px;
						height: 240px;

						@media only screen and (max-width: 860px) {
							word-break: break-all;
							word-wrap: break-word;
							margin: auto 0;
							width: 80%;
							margin-bottom: 20px;
						}
					}
				}

				.body-right {
					width: 50%;
					background: #DCDFE6;

					@media only screen and (max-width: 580px) {
						display: none;
					}

					// img {
					// 	margin-top: 20px;
					// 	margin-right: 30px;
					// 	width: 300px;
					// 	height: 90%;

					// 	@media only screen and (max-width: 1100px) {
					// 		margin: auto 0;
					// 		margin-top: 20px;
					// 		width: 80%;
					// 	}

					// 	@media only screen and (max-width: 700px) {
					// 		height: 80%;
					// 	}

					// 	@media only screen and (max-width: 600px) {
					// 		height: 70%;
					// 	}

					// }
				}

			}
		}

		//-----------------------------------------------关于我们-----------------------------------------------

		// .about {
		//   width: 100%;

		// }
		// .about_us {
		//   width: 1400px;
		//   margin: 0 auto;
		//   margin-top: 40px;
		//   display: flex;
		//   @media only screen and (max-width: 1400px) {
		//     width: 100%;
		//   }
		//   @media only screen and (max-width: 660px) {
		//     display: block;
		//   }

		//   .about-logo {
		//     display: flex;
		//     width: 48%;
		//     @media only screen and (max-width: 1280px) {
		//       display: block;
		//     }
		//     @media only screen and (max-width: 960px) {
		//       width: 50%;
		//     }
		//     @media only screen and (max-width: 670px) {
		//       width: 40%;
		//     }
		//     @media only screen and (max-width: 660px) {
		//       width: 100%;
		//       margin: auto 0;
		//     }
		//     img {
		//       margin-left: 180px;
		//       width: 160px;
		//       @media only screen and (max-width: 960px) {
		//         margin: auto 0;
		//         margin-left: 0;
		//       }
		//     }
		//     h2 {
		//       color: #666666;
		//       margin-top: 50px;
		//       @media only screen and (max-width: 1280px) {
		//         margin: 0;
		//         display: block;
		//         margin-left: 180px;
		//       }
		//       @media only screen and (max-width: 960px) {
		//         margin: auto 0;
		//         margin-left: 0;
		//       }
		//     }
		//   }

		//   .about-text {
		//     @media only screen and (max-width: 960px) {
		//       width: 50%;
		//     }
		//     @media only screen and (max-width: 660px) {
		//       width: 100%;
		//       margin: auto 0;
		//     }
		//     .about-content {
		//       margin-bottom: 30px;

		//       p {
		//         width: 480px;
		//         font-size: 14px;
		//         line-height: 30px;
		//         color: #666666;
		//         text-align: center;
		//         word-break: break-all;
		//         word-wrap: break-word;
		//         @media only screen and (max-width: 960px) {
		//           width: 100%;
		//         }
		//         @media only screen and (max-width: 660px) {
		//           width: 90%
		//         }
		//       }

		//     }
		//   }


		// }

	}
</style>
